import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { focusOutline } from '@design-system/theme';
import { DefaultLinkSimple } from './DefaultLinkSimple';
import { getLinkStyle, ignoredPropsConfig } from '../style';
export const DefaultLink = (_a) => {
    var { enableWrap = false, styledOnlyOnHover = false } = _a, otherProps = __rest(_a, ["enableWrap", "styledOnlyOnHover"]);
    return (_jsx(DefaultLinkWrapper, Object.assign({ enableWrap: enableWrap, styledOnlyOnHover: styledOnlyOnHover }, otherProps)));
};
const DefaultLinkWrapper = styled(DefaultLinkSimple).withConfig(ignoredPropsConfig) `
  ${getLinkStyle};
  ${focusOutline};
`;
//# sourceMappingURL=DefaultLink.js.map